<template>
<div id="contents">

  <div id="company" class="page_contents">

    <div id="company_contents">
      <div id="company_index">
        <div class="page_header">
          <h1 class="page_header_title">
            <img src="../assets/img/company/title.png" width="359" alt="WORKS" />
            <span>会社について</span>
          </h1><!-- .top_sec_title -->
        </div><!-- .page_header -->

        <companyPageNav />

        <div id="company_index_main" class="page_main_contents">

          <div class="recruit_2021_message" v-if="this.recruit_check()">
            <div class="logo">
              <img src="../assets/img/company/recruit_2021_logo_pink.png" alt="才能と挑戦に投資">
            </div>
            <p>当社は若手の「才能」「挑戦」を全面的にバックアップします。<br>マイナビのマイページからエントリーシートの提出をお願いします！</p>
          </div>

          <h1><img src="../assets/img/company/logo.png" width="635" alt="テレビ朝日映像" /></h1>

          <div class="company_message">
            <h3>ビジョン（ありたい姿）</h3>
            <p>テレビ朝日グループの成長を牽引する<br />トップクリエイター集団</p>
          </div><!-- .index_company_message -->

          <div class="company_credo">
            <h3>行動指針</h3>
            <p>私たちは、世の中に感動を届ける、真に「面白い」ヒットコンテンツを創造し続けます。</p>
            <p>未体験を楽しみ、挑む、「冒険者」であろう！<br />アイデアで常識を覆す、「発明家」であろう！<br />個性を讃え、高め合う、「オーケストラ」であろう！<br />こだわりと責任に向き合う、「職人」であろう！</p>
          </div><!-- .index_company_message -->

          <div id="company_index_main_inner">
            <p style="margin-bottom: 40px"><router-link v-bind:to="{ name : 'players_show', params : { id: 9784, referrer: 'company_index' }}" class="hover"><img src="../assets/img/company/top_message.png" width="800" alt="TOP MESSAGE" /></router-link></p>
            <p><router-link v-bind:to="{ name : 'sustainability_index', params: { company: 'sustainability'}}" class="hover"><img src="../assets/img/company/sustainability_company.png" width="800" alt="サスティナビリティへの取り組み" /></router-link></p>

            <ul class="company_logo_nav">
              <li><router-link v-bind:to="{ name : 'news_show', params : { id: 8048, referrer: 'company_index', link: true }}" class="btn btn-white">ロゴについて</router-link></li>
              <li><router-link v-bind:to="{ name : 'vivia_index', params:{link: true} }" class="btn btn-white">VIVIAとは？</router-link></li>
            </ul>
          </div><!-- #company_index_main_inner -->


        </div><!-- #company_index_main -->

        <div id="company_index_body" class="page_main_contents">

          <div class="company_index_list">
            <h3>社名</h3>
            <p>テレビ朝日映像株式会社</p>
          </div><!-- .company_index_list -->

          <div class="company_index_list">
            <h3>設立</h3>
            <p>1958年11月13日</p>
          </div><!-- .company_index_list -->

          <div class="company_index_list">
            <h3>資本金</h3>
            <p>7,500万円</p>
          </div><!-- .company_index_list -->

          <div class="company_index_list">
            <h3>従業員数</h3>
            <p>202名</p>
          </div><!-- .company_index_list -->

          <div class="company_index_list">
            <h3>本社所在地</h3>
            <p>〒106-0032 東京都港区六本木1-1-1<br />アーク放送センター<br />TEL 03-3587-8111　(代表) <a href="https://www.google.co.jp/maps/place/%E6%9D%B1%E4%BA%AC%E9%83%BD%E6%B8%AF%E5%8C%BA%E5%85%AD%E6%9C%AC%E6%9C%A8%EF%BC%91%E4%B8%81%E7%9B%AE%EF%BC%91%E2%88%92%EF%BC%91/@35.6665306,139.7405833,17z/data=!3m1!4b1!4m2!3m1!1s0x60188b9acca44791:0xe01d04a3d0658e67" class="google_map" target="_blank">＞GoogleMAP</a><span class="station">東京メトロ銀座線・南北線　溜池山王駅13番出口　徒歩5分<br />東京メトロ南北線　六本木一丁目駅3番出口　徒歩3分<br />都営バス都01系統　赤坂アークヒルズ前停留所　徒歩2分<br />東京メトロ日比谷線　六本木駅5番出口　徒歩12分<br />東京メトロ日比谷線　神谷町駅4a番出口　徒歩13分</span></p>
          </div><!-- .company_index_list -->

          <div class="company_index_list">
            <h3>役員</h3>
            <dl>
              <dt>代表取締役社長 兼<br />エグゼクティブプロデューサー</dt>
              <dd><br />若林 邦彦</dd>
              <dt>専務取締役</dt>
              <dd>宮川 晶</dd>
              <dt>取締役</dt>
              <dd>石井 宏</dd>
              <dt>取締役</dt>
              <dd>相川 憲一</dd>
              <dt>取締役</dt>
              <dd>秦 聖浩</dd>
              <dt>取締役 (非常勤)</dt>
              <dd>内藤 正彦 ㈱テレビ朝日</dd>
              <dt>監査役 (非常勤)</dt>
              <dd>長田 明 ㈱テレビ朝日ホールディングス</dd>
              <dt>
                <display-time>
                  <a class="business_organization_link" href="http://www.tv-asahipro.co.jp/pdf/business_organization.pdf" target="_blank">テレビ朝日映像株式会社 業務組織図</a>
                </display-time>
              </dt>
            </dl>
          </div><!-- .company_index_list -->

          <div class="company_index_list">
            <h3>事業内容</h3>
            <p>テレビ番組（地上波・BS・CS）の企画・制作<br />WEB、企業PR動画・CMなどあらゆる映像コンテンツの制作<br />各種イベントの企画・運営<br />広告代理店業務<br />撮影技術・編集技術</p>
          </div><!-- .company_index_list -->

          <div class="company_index_list">
            <h3>グループ会社</h3>
            <p><a href="http://viviap.co.jp/" target="_blank">株式会社びびあっぷ</a></p>
          </div><!-- .company_index_list -->

          <div class="company_index_list">
            <h3>加盟団体</h3>
            <p>全日本テレビ番組製作社連盟、 テレビ・ニュース映画協会、<br />スポーツニュース協会、 日本記者クラブ、一般社団法人 ACC、<br />日本アド・コンテンツ制作協会、全国放送派遣協会、<br />日本映像事業協会、日本映画テレビ技術協会</p>
          </div><!-- .company_index_list -->

        </div><!-- #company_index_body -->

      </div><!-- #company_index -->
    </div><!-- #company_contents -->
  </div><!-- #company -->



</div><!-- #contents -->
</template>

<script>
import displayTime from './display_time.vue';
import companyPageNav from './shared/companyPageNav.vue'
export default {
  name: 'company_index',
  components: {
    displayTime,
    companyPageNav
  },
  mounted () {
    const ts = this
    setTimeout(function(){
      ts.$emit('page_fade')
    },ts.$parent.page_load_time)
  },
  methods: {
    recruit_check(){
      return ['recruit_2021','recruit_2022','recruit_2023','recruit_2024'].includes(this.$route.name)
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/company_index.vue